import { useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from 'Douleutaras/redux/hooks';
import { getMe, selectMe, selectMeLoading } from 'Douleutaras/redux/data/users/meSlice';
import { SubscriptionTierPro } from 'Douleutaras/types';
import { selectCurrentUser } from 'Douleutaras/redux/data/auth/authSlice';

export const useSubscriptionTier = () => {
  const dispatch = useAppDispatch();
  const me = useAppSelector(selectMe);
  const loading = useAppSelector(selectMeLoading);
  const meError = useAppSelector(state => state.me.error);
  const storedUser = useAppSelector(selectCurrentUser);
  const isLoggedIn = Boolean(storedUser?.id);

  useEffect(() => {
    if (!me && isLoggedIn && !meError) {
      dispatch(getMe());
    }
  }, [me, meError]);

  return useMemo(() => {
    const tier = me?.subscriptionTier ?? SubscriptionTierPro.NONE;

    return {
      loading,
      currentSubscriptionTier: tier,
      isGoldTier: tier === SubscriptionTierPro.GOLD,
      isGoldOrSilverTier:
        tier === SubscriptionTierPro.GOLD ||
        tier === SubscriptionTierPro.SILVER
    };
  }, [me, loading]);
};
